import request from '../../utils/request';
import { Result } from '../../models/general';
import {
  ComplianceDashboardView,
  DeductionCapBreachView,
  ProbationWarningView,
  ComplianceEventView,
} from '../../models/payroll';

export async function getComplianceDashboard(year: number, month: number): Promise<Result<ComplianceDashboardView>> {
  const response = await request.get<Result<ComplianceDashboardView>>(`PayrollCompliance/Dashboard/${year}/${month}`);
  return response.data;
}

export async function getDeductionBreaches(year: number, month: number): Promise<Result<DeductionCapBreachView[]>> {
  const response = await request.get<Result<DeductionCapBreachView[]>>(`PayrollCompliance/DeductionBreaches/${year}/${month}`);
  return response.data;
}

export async function getProbationWarnings(): Promise<Result<ProbationWarningView[]>> {
  const response = await request.get<Result<ProbationWarningView[]>>('PayrollCompliance/ProbationWarnings');
  return response.data;
}

export async function getComplianceHistory(): Promise<Result<ComplianceEventView[]>> {
  const response = await request.get<Result<ComplianceEventView[]>>('PayrollCompliance/History');
  return response.data;
}

export async function resolveComplianceEvent(eventId: number): Promise<Result<boolean>> {
  const response = await request.post<Result<boolean>>(`PayrollCompliance/ResolveEvent/${eventId}`);
  return response.data;
}
